(() => {
  if (window.lbDeviceText) return;
  const media = matchMedia('(max-width:768px)');
  let queued = false;
  function refresh(scope = document) {
    queued = false;
    const suffix = media.matches ? '-mobile' : '-desktop';
    function applyAttributes(){scope.querySelectorAll('[data-lb-device-attrs]').forEach(node => {
      for (const key of node.getAttributeNames()) {
        if (!key.startsWith('data-lb-device-') || !key.endsWith(suffix)) continue;
        const attr = key.slice(15, -suffix.length);
        if (!attr || attr.startsWith('on') || attr === 'style') continue;
        if (window.lbPartDesign?.owns(node, attr) || window.lbNativeContent?.owns(node, attr)) continue;
        const value = node.getAttribute(key);
        if (attr === 'text') { if (node.textContent !== value) node.textContent = value; }
        else if (node.getAttribute(attr) !== value) node.setAttribute(attr, value);
      }
    });}
    applyAttributes();
    window.lbNativeContent?.refresh();
    window.lbPartDesign?.refresh();
    applyAttributes();
    document.dispatchEvent(new CustomEvent('lb:device-text')); 
  }
  function schedule(){if (!queued){queued=true;requestAnimationFrame(() => refresh());}}
  function attribute(node, key, desktop, mobile) {
    node.setAttribute('data-lb-device-attrs','');
    node.setAttribute('data-lb-device-'+key+'-desktop', desktop ?? '');
    node.setAttribute('data-lb-device-'+key+'-mobile', mobile ?? '');
    const value = media.matches ? mobile : desktop;
    node.setAttribute(key, value ?? '');
  }
  const observer = new MutationObserver(records => {
    if (records.some(r => r.type==='childList' || r.attributeName?.startsWith('data-lb-device-'))) schedule();
  });
  observer.observe(document.documentElement,{childList:true,subtree:true,attributes:true});
  media.addEventListener('change', () => refresh());
  document.addEventListener('DOMContentLoaded',schedule);
  document.addEventListener('shopify:section:load',schedule);
  window.lbDeviceText={refresh,attribute};
  schedule();
})();
